module.exports = __webpack_public_path__ + "static/img/fs1-6.2a4f1a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/fs1-6.png
// module id = 847
// module chunks = 0